import React, { useState, useEffect, useReducer } from 'react';
import { Image, Form, Button, Menu, MenuItem } from 'semantic-ui-react';
import auth from './../Login/auth';
import ReactDataGrid from 'react-data-grid';
import {Toolbar, Data} from "react-data-grid-addons";
import { CSVLink, CSVDownload } from "react-csv";
import logo from '../../img/Logo Horizontal Blanco transparente.png';

//Propiedades de las columnas
const defaultColumnProperties = {
    filterable: true
  };
  
  const EstadoFormatter = ({ value }) => {
    return <Button basic color='red' fluid='true' active='false' size='small'>{value}</Button>
  };

  //Columnas
  const columns = [
    {
      key: "nro_vta",
      name: "Nro. Vta.",
      width: 100
    },
    {
      key: "fecha",
      name: "Fecha",
      width: 110
    },
    {
      key: "cliente",
      name: "Cliente",
      width: 200
    },
    {
      key: "orden_fab",
      name: "Orden Fab.",
      width: 100
    },
    {
      key: "maquina",
      name: "Maquina",
      width: 150
    },
    {
      key: "estado_chasis",
      name: "Estado",
      width: 150,
      formatter: EstadoFormatter
    },
    {
      key: "cod_vendedor",
      name: "Zona",
      width: 100
    }
  ].map(c => ({ ...c, ...defaultColumnProperties })); 

const handleFilterChange = filter => filters => {
  const newFilters = { ...filters };
  if (filter.filterTerm) {
    newFilters[filter.column.key] = filter;
  } else {
    delete newFilters[filter.column.key];
  }
  return newFilters;
};

function getRows(rows, filters) {
  return selectors.getRows({ rows, filters });
} 

const selectors = Data.Selectors;

export const EstadoAvance = props => {
    const [dataNV, setDataNV] = useState([]);
    const [filters, setFilters] = useState({});
      
    const rows = dataNV;
    const filteredRows = getRows(rows, filters);  
    
    console.table(filteredRows);
  
    useEffect(() => {
      let mounted = true;
      getData()
        .then(items => {
          if(mounted) {
            setDataNV(items)
          }
        })
      return () => mounted = false;
    }, [])
  
    async function getData(){
      //var url = `http://192.168.87.41:8000/ctacte/${auth.db}/${cod_cli.trim()}?desde=${fechaDesde}&hasta=${fechaHasta}`; 
      var url = `http://webservices.crucianelli.com:8000//estadoAvance/${auth.cod_concesionario}`; 
  
      //query con fetch api asincronica
      let response = await fetch(url, {
        'mode': 'cors',
        'headers': {
            'Access-Control-Allow-Origin': '*',
        }
      });
      
      let data = await response.json();
      
      if (data.length !== 0) {
        return data;            
      }
    }

    return (    
        <div style={{width: '90%'}}>
            <Menu inverted color='red'>
                <MenuItem><h3>Estado Avance</h3></MenuItem>          
                <MenuItem><h5>{auth.nombre}</h5></MenuItem>
                <MenuItem position="right"><Image src={logo} size='small'></Image></MenuItem>       
            </Menu>
            <ReactDataGrid
                columns={columns}
                rowGetter={i => filteredRows[i]}
                rowsCount={filteredRows.length}
                minHeight={500}
                enableCellAutoFocus={false}
                toolbar={<Toolbar enableFilter={true} filterRowsButtonText = 'Filtrar' />}
                onAddFilter={filter => setFilters(handleFilterChange(filter))}
                onClearFilters={() => setFilters({})}
            />
            <CSVLink data={dataNV} filename={"estado_avance_notas_vta_" + new Date(Date.now()).toLocaleString().split(',')[0] + ".csv"}>Exportar a Excel.</CSVLink>
        </div>)
}    